import { call, put, takeEvery } from 'redux-saga/effects';
import * as type from '../../ActionTypes';
import {
  patchPaymentFixedStatusService,
  patchPaymentTimeSheetStatusService
} from '../../../services/payement/payment.service';
import { getMilestoneRecordService, getTimesheetRecordService } from '../../../services/timesheet';

function* patchPaymentTimeSheetRecord(action: any): any {
  try {
    const proposal = yield call(patchPaymentTimeSheetStatusService, action.payload, action.id);
    if (proposal.status === 200) {
      const timesheet = yield call(getTimesheetRecordService, action.contractID);
      const pdata = {
        type: timesheet.status === 200 ? type.GET_TIMESHEET_SUCCESS : type.GET_TIMESHEET_FAILURE,
        payload: timesheet.status === 200 ? timesheet.data : 'Oops, something went wrong!'
      };
      yield put(pdata);
    } else {
      yield put({
        type: type.PATCH_PAYMENT_TIMESHEET_FAILURE,
        error: 'Something went wrong'
      });
    }
  } catch (e: any) {
    yield put({ type: type.PATCH_PAYMENT_TIMESHEET_FAILURE, message: e.message });
    console.warn(e.message);
  }
}

function* patchPaymentFixedRecord(action: any): any {
  try {
    const fixedPayment = yield call(
      patchPaymentFixedStatusService,
      action.payload,
      action.proposalId
    );
    if (fixedPayment?.status === 200) {
      const milestone = yield call(getMilestoneRecordService, action.jobId);
      const pdata = {
        type: milestone.status === 200 ? type.GET_MILESTONE_SUCCESS : type.GET_MILESTONE_FAILURE,
        payload: milestone.status === 200 ? milestone.data : 'Oops, something went wrong!'
      };
      const patchPaymentdata = {
        type:
          milestone.status === 200
            ? type.PATCH_PAYMENT_FIXED_SUCCESS
            : type.PATCH_PAYMENT_FIXED_FAILURE,
        payload: fixedPayment.status === 200 ? fixedPayment.data : 'Oops, something went wrong!'
      };
      yield put(patchPaymentdata);
      yield put(pdata);
    } else {
      yield put({
        type: type.PATCH_PAYMENT_FIXED_FAILURE,
        error: 'Something went wrong'
      });
    }
  } catch (e: any) {
    yield put({ type: type.PATCH_PAYMENT_FIXED_FAILURE, error: e.message });
  }
}

function* payemnetStatusSaga() {
  yield takeEvery(type.PATCH_PAYMENT_FIXED_REQUEST, patchPaymentFixedRecord);
  yield takeEvery(type.PATCH_PAYMENT_TIMESHEET_REQUEST, patchPaymentTimeSheetRecord);
}

export default payemnetStatusSaga;
